import styled from 'styled-components';

export const ModuleCardContainer = styled.div`
    height: calc(100% - 16px);
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 12px;
    margin-bottom: 16px;
    flex-grow: 1;
    min-width: 240px;
    width: 330px;
    border-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
    -moz-box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
    -webkit-box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
    cursor: pointer;
    &:hover {
        opacity: 0.6
    }
`;

export const ClearCardContainer = styled.div`
    align-items: center;
    justify-content: center;
    height: calc(100% - 16px);
    display: flex;
    padding: 4px;
    margin-bottom: 16px;
    border-radius: 6px;
    border: 1px solid #D9D9D9;
    cursor: pointer;
    &:hover {
        opacity: 0.6
    }
`;

export const ModuleTitle = styled.div`
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
`;

export const ModuleDescription = styled.span`
    text-align: justify;
    font-size: 14px;
    opacity: 0.7
`;